module.exports = __webpack_public_path__ + "static/img/1010.a1758bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/notice/1010.png
// module id = KmxB
// module chunks = 1